type Locales = {
  [key: string]: string
}
export const LOCALES: Locales = {
  en: 'en-US',
  ua: 'uk-UA',
}
export const langList = Object.keys(LOCALES)
export const localesList = Object.values(LOCALES)
